<template>
  <div class="tinymce-box">
    <editor v-model="myValue" :init="init"></editor>
    <!--    <p v-if="this.Num" >字数:还可以输入<span style="color: red">{{ Num-enterNum>=0 ? Num-enterNum : 0 }}</span>个字符，不少于20字符，最多可输入{{ Num }}个字符（含标点及空格）</p>-->
    <p v-if="this.Num">
      {{ $t("common.tinymce1")
      }}<span style="color: red">{{
        Num - enterNum >= 0 ? Num - enterNum : 0
      }}</span
      >{{ $t("common.tinymce2") }}{{ Num }}{{ $t("common.tinymce3") }}
    </p>
  </div>
</template>

<script>
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/icons/default/icons";
import "tinymce/plugins/image"; // 插入上传图片插件
import "tinymce/plugins/media"; // 插入视频插件
import "tinymce/plugins/table"; // 插入表格插件
import "tinymce/plugins/lists"; // 列表插件
import "tinymce/plugins/wordcount"; // 字数统计插件

// 引入富文本编辑器主题的js和css
import "tinymce/themes/silver/theme.min.js";
import { editorResourceUrl, baseFileUrl, forMat } from "../../../utils/common.js";
import axios from "axios";
// import 'tinymce/icons/default/icons' // 解决了icons.js 报错Unexpected token '<'
import { uploadImg } from "../../../api/common";
export default {
  name: "Tinymce",
  data() {
    return {
      lange:'',
      myValue: this.value,
      imgDown:forMat(),
      resultUrl: "",
      enterNum: "",
      recordValue: "",
      init: {
        language_url: `${this.baseUrl}/tinymce/langs/zh_CN.js`,
        language:'',
        skin_url: `${this.baseUrl}/tinymce/skins/ui/oxide`,
        // skin_url: 'tinymce/skins/ui/oxide-dark', // 暗色系
        convert_urls: false,
        height: 300,
        // content_css（为编辑区指定css文件）,加上就不显示字数统计了
        // content_css: `${this.baseUrl}tinymce/skins/content/default/content.css`,
        // （指定需加载的插件）
        // plugins: this.plugins,
        plugins: "image media table lists",
        toolbar: this.toolbar, // （自定义工具栏）
        statusbar: true, // 底部的状态栏
        menubar: "file edit insert view format table tools help", // （1级菜单）最上方的菜单
        branding: false, // （隐藏右下角技术支持）水印“Powered by TinyMCE”
        // 此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
        // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
        images_upload_handler: (blobInfo, success, failure) => {
          // const img = 'data:image/jpeg;base64,' + blobInfo.base64();
          // const ImguploadUrl=this.imgDown   // axios 图片上传路径
          let form = new FormData();
          form.append("file", blobInfo.blob());
          //调取接口
         // let result = this.upload(form, success);
          uploadImg(form).then(res=>{
            let result = res.data.data.url
            // console.log("这个请求得结果集",result);
            if(result.indexOf("http")  == -1){
              result= this.imgDown + result;
            }
            success(result);
          })
      
        },
      
      },
    };
  },
  props: {
    data: {
      type: String,
      default: "",
    },
    baseUrl: {
      type: String,
      default: editorResourceUrl(),
    },
    Num: {
      type: Number,
      default: 0,
    },
  },

  components: {
    Editor,
  },
  computed: {},
  created(){
      if(localStorage.getItem('lang')=='en'){
        this.init.language="en"
      }else{
        this.init.language="zh_CN"
        this.lange='zh_CN'
      }
      // console.log(this.lange);
  },
  methods: {
    getContent() {
      return this.myValue;
    },
    //去掉html标签
    removeHTMLTag(str) {
      str = str.replace(/<\/?[^>]*>/g, "");
      str = str.replace(/[ | ]*\n/g, "\n");
      str = str.replace(/&nbsp;/gi, "");
      str = str.replace(/\s/g, "");
      str = str.replace(/(\s|&nbsp;)+/g, " ");
      return str;
    },
    //上传图片函数
    // async upload(formdata) {
    //   let { data } = await uploadImg(formdata);
    //   console.log("上传成功得数据", data);
    //   let resultUrl = data.data.url;
    //   // console.log('上传成功返回得img路径',resultUrl);
    //   resultUrl =this.imgDown+resultUrl;
      
    //    console.log("****",resultUrl);
    //    return resultUrl;
  
    // },
  },
  mounted() {

     if(localStorage.getItem('lang')=='en'){
        this.lange='en'
      }else{
        this.lange='zh_CN'
      }  
    tinymce.init({});
    this.myValue = this.data;

  },
  watch: {
    myValue(newValue, oldValue) {
      // console.log(oldValue,this.enterNum);
      this.enterNum = this.removeHTMLTag(newValue).length;
    },
    enterNum(newValue, oldValue) {
      // if (newValue > this.Num) {
      //   this.myValue = this.myValue.slice(0, this.Num)
      // }
    },
    data(newValue, oldValue) {
      // console.log(newValue, oldValue)
      if (newValue !== oldValue) {
        this.myValue = newValue;
      }
    },
    lange(newValue, oldValue){
      // console.log("变化了");
       tinymce.init({});

    }
  },
};
</script>
<style lang="scss" scoped>
.tinymce-box {
  p {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 19px;
  }
}
</style>
